import { IList } from '../../../../../types/ComponentTypes/Components'
import { Label } from '@sainsburys-tech/luna-form'

function ListComponent({ label, subLabel, listValues }: IList) {
  return (
    <div id="s-reporting-list">
      <Label htmlFor=""> {label} </Label>
      <p style={{margin: 0}}>{subLabel}</p>
      <ul className="s-reporting-list">
        {listValues.map((list, index) => (
          <li id="s-reporting list" key={index}>
            {list}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ListComponent
